<template>
	<div class="view">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.view {
		cursor: grab;
	}
</style>